import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_PRODUCT_PAGE_NAME } from '../../../constants/service/app/recommendProductConstants';
import RecommendProductDetailContainer from '../../../containers/recommend/product/RecommendProductDetailContainer';

const RecommendProductDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_PRODUCT_PAGE_NAME.RECOMMEND_PRODUCT_DETAIL}>
      <RecommendProductDetailContainer />
    </PageTemplate>
  );
};

export default RecommendProductDetail;
